import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export const Search = ()=>/*#__PURE__*/ _jsxs("svg", {
        width: "33",
        height: "32",
        viewBox: "0 0 33 32",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ _jsx("title", {
                children: "search-icon"
            }),
            /*#__PURE__*/ _jsx("g", {
                clipPath: "url(#clip0_2847_1861)",
                children: /*#__PURE__*/ _jsx("path", {
                    fillRule: "evenodd",
                    clipRule: "evenodd",
                    d: "M21.1385 22.3027C18.9258 24.1924 16.0545 25.3333 12.9167 25.3333C5.92106 25.3333 0.25 19.6623 0.25 12.6667C0.25 5.67106 5.92106 0 12.9167 0C19.9123 0 25.5833 5.67106 25.5833 12.6667C25.5833 15.8045 24.4424 18.6758 22.5527 20.8885L31.6238 29.9596C32.0143 30.3501 32.0143 30.9832 31.6238 31.3738C31.2332 31.7643 30.6001 31.7643 30.2096 31.3738L21.1385 22.3027ZM23.5833 12.6667C23.5833 18.5577 18.8077 23.3333 12.9167 23.3333C7.02563 23.3333 2.25 18.5577 2.25 12.6667C2.25 6.77563 7.02563 2 12.9167 2C18.8077 2 23.5833 6.77563 23.5833 12.6667Z",
                    fill: "url(#paint0_linear_2847_1861)"
                })
            }),
            /*#__PURE__*/ _jsxs("defs", {
                children: [
                    /*#__PURE__*/ _jsxs("linearGradient", {
                        id: "paint0_linear_2847_1861",
                        x1: "0.25",
                        y1: "0",
                        x2: "31.9167",
                        y2: "31.6667",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ _jsx("stop", {
                                stopColor: "#311C77"
                            }),
                            /*#__PURE__*/ _jsx("stop", {
                                offset: "1",
                                stopColor: "#FF2DFF"
                            })
                        ]
                    }),
                    /*#__PURE__*/ _jsx("clipPath", {
                        id: "clip0_2847_1861",
                        children: /*#__PURE__*/ _jsx("rect", {
                            width: "32",
                            height: "32",
                            fill: "white",
                            transform: "translate(0.25)"
                        })
                    })
                ]
            })
        ]
    });
